<button [class]="buttonClass" [disabled]="this.disabled">
	<label>
		{{ label | translate}}
	</label>
	<img *ngIf="icon" width="16px" [src]="icon" alt="icon-button"/>
</button>
